import React from "react";
import PropTypes from "prop-types";
import styles from "./NotFoundMessage.css";

const NotFoundMessage = ({ errorMessage, suggestionMessage }) => (
  <div className={styles.wrapper}>
    <p data-auto-id="errorMessage" className={styles.errorMessage}>
      {errorMessage}
    </p>
    <p data-auto-id="suggestionMessage" className={styles.suggestionMessage}>
      {suggestionMessage}
    </p>
  </div>
);

NotFoundMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  suggestionMessage: PropTypes.string.isRequired
};

export default NotFoundMessage;
